import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';

interface LoadingSpinnerProps {
  isLoading: boolean;
  isTable?: boolean;
  colSpan?: number;
  label?: string;
}

export default function LoadingSpinner({
  isLoading,
  isTable = false,
  colSpan = 1,
  label,
  children,
}: PropsWithChildren<LoadingSpinnerProps>) {
  if (!isLoading) {
    return <>{children}</>;
  }
  if (isTable) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} sx={{ textAlign: 'center' }}>
          <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
            <CircularProgress size={24} />
            {label && <Typography variant="body2" color="text.secondary">{label}</Typography>}
          </Stack>
        </TableCell>
      </TableRow>
    );
  }
  return (
    <Stack
      sx={{
        padding: 4,
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        minHeight: '200px',
      }}
    >
      <CircularProgress />
      {label && (
        <Typography variant="body1" color="text.secondary" fontWeight={500}>
          {label}
        </Typography>
      )}
    </Stack>
  );
}

